import React from "react";
import PropTypes from "prop-types";

import { SystemBanner } from "account/systembanner";

import styles from "./topnav.css";

export function TopNav() {
  return (
    <div className={styles.topNavWrapper}>
      <SystemBanner />
      <div id="topnavcontainer" className={`${styles.topnav} shadow-6dp`} />
    </div>
  );
}

TopNav.propTypes = {
  topMenu: PropTypes.any
};
